import styles from "./styles.module.scss";

export default function Users() {
  return (
    <div className={styles.container}>
      <h1 className="text-success">Users</h1>
    </div>
  );
}
